import { Inbox } from "lucide-react";

export default function EmptyState({ icon: Icon = Inbox, title, description, action, testId }) {
    return (
        <div className="co-card co-card-pad flex flex-col items-center justify-center gap-3 text-center py-12" data-testid={testId}>
            <div className="grid h-10 w-10 place-items-center rounded-full bg-zinc-100 text-zinc-500">
                <Icon className="h-5 w-5" />
            </div>
            <div className="font-display text-lg font-medium">{title}</div>
            {description && <p className="text-sm text-[#5E636E] max-w-md">{description}</p>}
            {action}
        </div>
    );
}
